import { UnknownAction } from "@reduxjs/toolkit";
import { INotificationAction, NotificationsStatusType } from "dataModels/stateModels/notification";
import { TFunction } from "i18next";
import { Dispatch } from "react";
import { ResponseCode, ResponseStatus } from "shared/constants";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";

export const buildPopUp = (
    dispatch:Dispatch<UnknownAction>,
    response:any,
    t:TFunction<[string, string], undefined>,
    titleError:string,
    titleWarning:string,
    titleSuccess:string,
    descriptionSuccess:string,
    ) => {
    let popUpAction: INotificationAction;
    
    let myResponse = undefined;
    if(response.data){
        myResponse=response.data;
    }else{
        myResponse=response
    }

    const popUpTitle:string = myResponse.status===ResponseStatus.ERROR ? titleError:(myResponse.code===ResponseCode.UNPROCESSABLE_CONTENT? titleWarning : titleSuccess );
    const popUpDescription:string = (response.status===ResponseStatus.ERROR||myResponse.code===ResponseCode.UNPROCESSABLE_CONTENT)?myResponse.message:descriptionSuccess;
    const popUpStatus:NotificationsStatusType = myResponse.status===ResponseStatus.ERROR?"error":(myResponse.code===ResponseCode.UNPROCESSABLE_CONTENT?"error":"confirm");
    popUpAction = {
        show: true,
        title: popUpTitle,
        description: popUpDescription,
        status: popUpStatus,
        onClose: (event: Event) => {
            dispatch(hideNotification());
        }
    };
    dispatch(showNotification(popUpAction));
}

